import Phaser from 'phaser';
import { CST } from '../CST';

export default class Boot extends Phaser.Scene {
	constructor() {
		super(CST.SCENES.BOOT);
	}

	preload() {
		this.load.image('loading-bg', 'assets/loading.webp');
		this.load.on('complete', () => {
			this.scene.start(CST.SCENES.PRELOAD);
		});
	}

	create() {}
}
